import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "simple-dialog",
  templateUrl: "simple-dialog.html",
  styleUrls: ["./simple-dialog.scss"]
})
export class SimpleDialog implements OnInit {
  constructor(private dialogRef: MatDialogRef<SimpleDialog>) {}

  @Input() icon: string;
  @Input() iconColor: string;
  @Input() titleText: string;
  @Input() titleColor: string;
  @Input() text: string;
  @Input() confirmButtonText: string;
  @Input() cancelButtonText: string;
  @Output() callbackConfirm = new EventEmitter<string>();
  @Output() callbackCancel = new EventEmitter<string>();

  ngOnInit() {}

  confirm() {
    this.callbackConfirm.emit();
    this.dialogRef.close();
  }

  close() {
    this.callbackCancel.emit();
    this.dialogRef.close();
  }
}
